var React = require('react');

function Github (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M59.4479 75.4197V61.0528C72.6669 55.2982 75.1064 49.7681 71.4851 36.202V23L59.4479 28.0478H41.9747L32.6556 23V32.7074C26.063 50.1969 30.3516 54.9926 41.9747 61.0528V75.4197","stroke":"black","strokeWidth":"2.5","key":0}),React.createElement("path",{"d":"M42.7552 70.3719H36.5425C34.8757 68.8461 33.7759 66.9967 31.4946 61.8295H28","stroke":"black","strokeWidth":"2.5","key":1})]);
}

Github.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Github;

Github.default = Github;
